module.exports = __webpack_public_path__ + "img/baidu-logo.666791df.png";